export class TextHelper {
    getPropertyNameRegex() {
        return /[\&\(\)\?\-\=\'\"\§\!\%\:\_\s.]+(.)?/g;
    }
    removeZeroWidthCharacters(str) {
        return str.replace(/[\u200B-\u200D\uFEFF]/g, '');
    }
    addUnderscoreWhenStarsWithNumber(str) {
        if (this.startsWithNumber(str)) {
            return `_${str}`;
        }
        return str;
    }
    startsWithNumber(str) {
        if (str.match(/^\d/)) {
            return true;
        }
        return false;
    }
}
export const textHelper = new TextHelper();
//# sourceMappingURL=text-helper.js.map